<template>

  <div class="vflex">
    <div v-if="title" class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ title }}</h4>
        </div>
      </div>
    </div>
    <creating
      v-if="creating"
      height="100%" />
    <div
      v-if="!creating"
      class="vflex-row-1">
      <div class="main-form">
        <div class="p-3"><slot></slot></div>
        <div class="actions p-3" :class="{'box-loading': loading}">
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Form',
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    creating: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-form {
  position: relative;
  height: 100%;
  overflow: auto;
}
.main-form > .actions {
  position: sticky;
  bottom: 0;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/Form.vue